import styled from "styled-components";
import sad from "../../../assets/images/sad.svg";

const DzoSeparatedUnsubscribeDisplay = styled.div`
  min-height: 100vh;
`;

export default DzoSeparatedUnsubscribeDisplay;

export const Unsubscribe = styled.div`
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0 16px;

  .sad {
    background: url(${sad}) center center no-repeat;
    height: 82px;
    padding: 56px 0;
  }

  p.confirmQues {
    font-size: 16px;
    font-weight: bold;
    color: var(--unSubscribeColor, var(--gamename));
    margin-bottom: 24px;
  }

  .unsubscribe-form {
    width: 100%;
    max-width: 320px;
    margin-bottom: 24px;
  }

  .phone-input-group {
    display: flex;
    gap: 8px;
    margin-bottom: 16px;
  }

  .input {
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.35);
    background: rgba(0, 0, 0, 0.25);
    color: white;
    padding: 12px;
    font-size: 16px;
    outline: none;
  }

  .prefix-input {
    width: 72px;
    text-align: center;
  }

  .phone-input {
    flex: 1;
  }

  .unsubscribe-btn {
    width: 100%;
    margin-top: 8px;
  }

  .normBtn {
    margin-top: 8px;
  }
`;
